import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect, useDispatch, useSelector } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { injectIntl, intlShape } from '../../util/reactIntl';
import { Page, LayoutSingleColumn, IconSpinner } from '../../components';
import TopbarContainer from '../TopbarContainer/TopbarContainer';
import FooterContainer from '../FooterContainer/FooterContainer';
import { withViewport } from '../../util/uiHelpers';
import { useConfiguration } from '../../context/configurationContext';
import { isScrollingDisabled } from '../../ducks/ui.duck';

import css from './FAQPage.module.css';

import facebookImage from '../../assets/biketribe-facebook-sharing-1200x630.jpg';
import twitterImage from '../../assets/biketribe-twitter-sharing-600x314.jpg';
import FAQSection from './FAQSection';
import { fetchAllFaqs, getFaqsSelector } from '../../ducks/strapi.duck';
import { isArrayLength } from '../../util/genericHelpers';

export const FAQPageComponent = props => {
  const { intl, scrollingDisabled } = props;

  const config = useConfiguration();
  const dispatch = useDispatch();

  const marketplaceName = config.marketplaceName;

  const schemaTitle = intl.formatMessage({ id: 'FAQPage.schemaTitle' }, { marketplaceName });
  const schemaDescription = intl.formatMessage({ id: 'FAQPage.schemaDescription' });
  const schemaImage = `${config.marketplaceRootURL}${facebookImage}`;

  useEffect(() => {
    dispatch(fetchAllFaqs({}));
  }, [dispatch]);

  const faqsData = useSelector(getFaqsSelector) || [];

  // Extract unique tag names and add 'All' tab
  const uniqueTags = Array.from(
    new Set(faqsData.map(faq => faq.tag?.name).filter(Boolean))
  );
  const tags = ['All', ...uniqueTags];

  const [activeTab, setActiveTab] = useState('All');

  // Filter FAQs based on active tab
  const filteredFaqs =
    activeTab === 'All'
      ? faqsData
      : faqsData.filter(faq => faq.tag?.name === activeTab);

  return (
    <Page
      className={css.root}
      scrollingDisabled={scrollingDisabled}
      contentType="website"
      description={schemaDescription}
      title={schemaTitle}
      facebookImages={[{ url: facebookImage, width: 1200, height: 630 }]}
      twitterImages={[
        {
          url: `${config.marketplaceRootURL}${twitterImage}`,
          width: 600,
          height: 314,
        },
      ]}
      schema={{
        '@context': 'http://schema.org',
        '@type': 'WebPage',
        description: schemaDescription,
        name: schemaTitle,
        image: [schemaImage],
      }}
    >
      <LayoutSingleColumn
        className={css.pageRoot}
        topbar={<TopbarContainer />}
        footer={<FooterContainer />}
      >
        <div className={css.pageContent}>
          <div className={css.faqHead}>
            <span>{intl.formatMessage({ id: 'FAQPage.faqLabel' })}</span>
            <h1>{intl.formatMessage({ id: 'FAQPage.helpTitle' })}</h1>
            <p>{intl.formatMessage({ id: 'FAQPage.helpDescription' })}</p>
          </div>

          {isArrayLength(faqsData) ? (
            <>
              <div className={css.tabContainer}>
                {tags.map(tag => (
                  <button
                    key={tag}
                    className={`${css.tabButton} ${activeTab === tag ? css.active : ''}`}
                    onClick={() => setActiveTab(tag)}
                  >
                    {tag}
                  </button>
                ))}
              </div>
              <FAQSection faqsData={filteredFaqs} />
            </>
          ) : (
            <div className={css.iconSpinner}>
              <IconSpinner />
            </div>
          )}
        </div>
      </LayoutSingleColumn>
    </Page>
  );
};

FAQPageComponent.propTypes = {
  scrollingDisabled: PropTypes.bool.isRequired,
  intl: intlShape.isRequired,
};

const mapStateToProps = state => {
  return {
    scrollingDisabled: isScrollingDisabled(state),
  };
};

const FAQPage = compose(
  withRouter,
  connect(mapStateToProps, null),
  withViewport,
  injectIntl
)(FAQPageComponent);

export default FAQPage;
